import { useContext, useEffect, useMemo, useState } from 'react'
import { AppContext } from '../context'
import useUserStorage from './useUserStorage'
import useDataClient from './useDataClient'
import { CurpProfile } from '../types'
import { sarenvAdapter } from '../adapter/sarsetting.adapter'

export default function useCurpDataCache(): [curpDataTarget: CurpProfile | null, setCurpTarget: (curp: string) => void] {
    const appContext = useContext(AppContext)
    const localData = useUserStorage<CurpProfile[]>('curpAmbientacion')
    const validateCurpClient = useDataClient<CurpProfile>({ appContext })
    const [curp, setCurp] = useState('')
    const currentCurpData = useMemo<CurpProfile | null>(() => {
        if (!curp) {
            validateCurpClient.clean()
            return null
        }
        let validatedCurp = curp.toUpperCase()
        let curpInCache = localData.data?.find(c => c.curp === validatedCurp)
        if (curpInCache) {
            return curpInCache
        }
        validateCurpClient.executeRequest(sarenvAdapter.validateCurp(validatedCurp))
        return null
    }, [curp, localData.data])


    useEffect(() => {
        if (validateCurpClient.status.data) {
            localData.setData([...(localData.data || []), validateCurpClient.status.data])
        }
    }, [validateCurpClient.status.data])

    return [currentCurpData, setCurp]
}
